const Personas = ({ data }) => {
  if (!data) return null;

  const tooltips = [
    "The big picture view! See how the entire organization is performing, where risks are piling up, and if you're about to hit any funding cliffs. Perfect for executive decision-making.",
    "Team manager central! Track your team's workload so nobody gets overwhelmed, see cycle times to spot bottlenecks, and flag high-risk actions that need extra attention.",
    "Your personal mission control! See your queue of actions, get alerts when something needs attention, and access AI-powered templates and clause suggestions to work faster.",
    "Money tracker! Monitor obligations so nothing falls through the cracks, catch under-obligation risks early, and get warnings before funding expires. No more scrambling at fiscal year-end!",
    "Program-focused lens! See all actions, vendors, and performance data organized by YOUR programs - not buried in enterprise-wide reports you have to dig through.",
    "Team collaboration hub! Legal, Budget, HR, Tech, Security, and Integration teams all work in one place instead of separate tools. Everyone sees the same info at the same time."
  ];

  return (
    <section className="py-16 px-6" data-testid="personas-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold mb-8">{data.title}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {data.items.map((persona, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-xl hover:border-purple-300 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden min-h-[120px]"
              data-testid={`persona-${index}`}
              data-robot-tooltip={tooltips[index]}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600/10 to-blue-600/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative z-10">
                <h3 className="text-base font-semibold mb-2 text-gray-900">
                  {persona.title}
                </h3>
                <p className="text-sm text-gray-600">{persona.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <h3 className="text-2xl font-bold mb-4">Friendly for novices, fast for experts.</h3>
          <p className="text-gray-600 mb-4 leading-relaxed">
            New users get guided flows, plain-language explanations, and traffic-light risk indicators that spell out
            "what this means" and "what to do next." Power users can drill into the underlying data and keep a complete audit trail.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Goal: let humans focus on judgment, negotiation, and policy. AcuSightPro handles the reading, structuring, and first-draft work.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Personas;
